import PagesNavigationBarComponent from '../components/PagesNavigationBar';
import Box from 'carbon-react/esm/components/box';
import { LayoutProps } from './types/layout.types';
import { PrivateNavBarErrorBoundary } from './ErrorBoundary/PrivateNavBarErrorBoundary';

export const PrivateNavBarLayout = ({ children, withErrorBoundary }: LayoutProps) => {
  const content = withErrorBoundary ? (
    <PrivateNavBarErrorBoundary errorLayout="PrivateNavBarLayout">
      {children}
    </PrivateNavBarErrorBoundary>
  ) : (
    children
  );

  return (
    <Box display="flex" flex="1" flexDirection="column">
      <PagesNavigationBarComponent />
      <Box
        as="main"
        display="flex"
        flex="1"
        flexDirection="column"
        pr={40}
        pl={40}
        borderRadius="borderRadius000"
      >
        {content}
      </Box>
    </Box>
  );
};
